module.exports = {
    blog_title:'Taption Blog',
    blog_desc:'Nützliche Artikel und hilfreiche Tipps für Ersteller. Produktaktualisierungen, Neuigkeiten und Infos von Taption.',
    written_by: 'Geschrieben von', 
}
